module.exports = __webpack_public_path__ + "search.svg?610bb998cd2c230e6a4c17d6e45d42d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search.svg
// module id = 84
// module chunks = 0